import { Button, Col, Container, Modal, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import BaseModal from './BaseModal'
import { mediaQueryPoint, useMediaQuery } from 'utils/hooks'
import { Link } from 'react-router-dom'
import { makeData } from 'utils/makeData'
import coinIcon from 'assets/images/coin.svg'
import { PATHS } from 'config/routes'
import { useState, useEffect, useContext } from 'react'
import { SocketContext } from 'utils/socket'
import { useNavigate } from 'react-router-dom'
import avaDefault from 'assets/images/ava-default.jpeg'
import { useDispatch } from 'react-redux'
import { showSnackbar } from 'store/actions'

function InviteModal({ ...otherProps }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const isMobileMD = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)

	const [openModalInvite, setOpenModalInvite] = useState(true)
	const [dataInvite, setDataInvite] = useState(null)
	const [disableButtonJoin, setDisableButtonJoin] = useState(false)

	const closeInviteModal = () => {
		setOpenModalInvite(false)
	}
	const { socket, setSocketRoomId } = useContext(SocketContext)
	const navigate = useNavigate()
	useEffect(() => {
		socket.on('received invite', data => {
			setOpenModalInvite(true)
			setDataInvite(data)
		})

		socket.on('join room success', data => {
			closeInviteModal()
			setSocketRoomId(data.room_id)
			setDisableButtonJoin(false)
			navigate(
				PATHS.PLAYROOM_PAGE.replace(':roomId', data.game_id).replace(
					':gameId',
					data.room_id,
				),
			)
		})

		socket.on('join room error', message => {
			closeInviteModal()
			setDisableButtonJoin(false)
			dispatch(showSnackbar(true, message || "Can't join room now!", 'error'))
			navigate(-1)
		})
		socket.on('joined room', () => {
			closeInviteModal()
		})
	}, [socket])

	const onPressAcceptJoinRoom = () => {
		if (socket && socket.connected && dataInvite) {
			socket.emit('join room', { room_id: dataInvite.room_id })
			setDisableButtonJoin(true)
			navigate(PATHS.ROOM_PAGE.replace(':roomId', dataInvite.game_id))
		}
	}
	if (!dataInvite || !openModalInvite) return null
	return (
		<BaseModal show={openModalInvite} onHide={closeInviteModal} {...otherProps}>
			<Container fluid className="invite-modal">
				<Modal.Header>
					<Modal.Title
						id="contained-modal-title-vcenter"
						style={isMobileMD ? { fontSize: 20, lineHeight: '24px' } : null}
					>
						{t('modal.invite.invitation')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Container fluid className="invite-list invitation">
						<Row>
							<Col
								xs={4}
								className="d-flex flex-column align-items-center justify-content-between"
							>
								<div className="friend-info__ava invitation">
									<img
										src={dataInvite.user_image || avaDefault}
										alt="Friend's avatar"
									/>
								</div>
								<p
									style={{ textAlign: 'center' }}
									className="friend-info__name"
								>
									{dataInvite.user_full_name}
								</p>
								<div className="bet-box invitation d-flex justify-content-center align-items-center">
									<img src={coinIcon} alt="User's bet" className="me-2" />
									<p>
										{new Intl.NumberFormat('lo').format(dataInvite.user_coin)}
									</p>
								</div>
							</Col>
							<Col xs={8} className="game-desc">
								<Row className="game-desc__info">
									<p className="me-2">{t('modal.invite.game')}:</p>
									<p>{dataInvite.game_name}</p>
								</Row>
								<Row className="game-desc__info">
									<p className="me-2">{t('modal.invite.room_id')}:</p>
									<p>{dataInvite.room_id}</p>
								</Row>
								<Row className="game-desc__info">
									<p className="me-2">{t('modal.invite.bet')}:</p>
									<p>{dataInvite.bet_level}</p>
								</Row>
								<Row></Row>
							</Col>
						</Row>
					</Container>
				</Modal.Body>
				<Modal.Footer className="roompage-invite">
					<Button variant="dark" onClick={closeInviteModal}>
						{t('modal.btn.cancel')}
					</Button>

					<Button
						variant="secondary"
						onClick={onPressAcceptJoinRoom}
						disabled={disableButtonJoin}
					>
						{t('modal.btn.agree')}
					</Button>
				</Modal.Footer>
			</Container>
		</BaseModal>
	)
}

export default InviteModal
